var $ = require('jquery');

$(function () {
    $("#search-overlay-form").on("submit", function () {
        var searchQueryInput = $(this).find(".ws-search-form__search-phrase").val();
        if (typeof searchQueryInput === "undefined" || searchQueryInput === null || searchQueryInput.length === 0) {
            return false;
        }
    });
});